import "./block-numbers.scss";

const $ = jQuery.noConflict();

function initBlockNumbers() {
    if ($(".number-animated").length === 0) {
        return;
    }

    // eslint-disable-next-line no-undef, no-new
    new Waypoint({
        element: $(".number-animated")[0],

        handler() {
            $(".number-animated").each(function onEach() {
                const $this = $(this);
                const number = Number.parseFloat(
                    $this.text().replaceAll(",", "")
                );

                if (Number.isInteger(number)) {
                    $({ Counter: 0 }).animate(
                        { Counter: number },
                        {
                            duration: 1000,
                            easing: "swing",

                            step(now) {
                                $this.text(Math.ceil(now).toLocaleString());
                            },
                        }
                    );
                } else {
                    $({ Counter: 0 }).animate(
                        { Counter: number },
                        {
                            duration: 1000,
                            easing: "swing",

                            progress() {
                                // eslint-disable-next-line no-magic-numbers
                                $this.text(Math.ceil(this.Counter * 10) / 10);
                            },
                        }
                    );
                }
            });

            this.destroy();
        },

        offset: "bottom-in-view",
    });
}

$(document).ready(function onReady() {
    initBlockNumbers();
});

if (window.acf) {
    window.acf.addAction("render_block_preview", initBlockNumbers);
}
